module.exports = __webpack_public_path__ + "img/21.10093ecc.jpg";